import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Compress = ({ size = 16, color = 'var(--moveo-hover-02)', }) => {
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: "none", viewBox: "0 0 35 35", children: [_jsx("rect", { width: size, height: size, fill: color, rx: "2" }), _jsx("path", { fill: "#fff", d: "M5 16h4v5H5zM5 22h4v2H5zM5 25h4v2H5zM5 28h4v2H5zM5 31h4v2H5z" })] }));
};
